import { lazy } from 'react';

import type { WidgetMapper } from 'ui/containers/ContentBuilder';

const creditcardpaymentcanceled = lazy(
  () =>
    import(
      /* webpackChunkName: "container-order-credit-card-payment-process-v2" */ './PaymentCreditCard'
    ),
);

const creditcardpaymentcompleted = lazy(
  () =>
    import(
      /* webpackChunkName: "container-order-credit-card-payment-process-v2" */ './PaymentCreditCard'
    ),
);

const creditcardpaymentprocess = lazy(
  () =>
    import(
      /* webpackChunkName: "container-order-credit-card-success-processing-v2" */ './PaymentCreditCard'
    ),
);

export const orderCreditCardCanceledMapper: WidgetMapper = {
  creditcardpaymentcanceled,
};

export const orderCreditCardPaymentCompletedMapper: WidgetMapper = {
  creditcardpaymentcompleted,
};

export const orderCreditCardPaymentProcessMapper: WidgetMapper = {
  creditcardpaymentprocess,
};
